import React from "react";
import {StyledFooter} from "./ui";
import {LogoMobileIcon} from "../../assets/icons/index";

const Footer = () => {
  return (
    <StyledFooter>
      <p>
          <LogoMobileIcon/>
      </p>
      <p>
        <span>Privacy Policy</span>
      </p>
      <p>Copyright @ 2020-2021 Exsportia. All rights reserved</p>
    </StyledFooter>
  );
};

export default Footer;
